import { render, staticRenderFns } from "./ui-audio-control.vue?vue&type=template&id=4ddfc6fa&scoped=true"
import script from "./ui-audio-control.vue?vue&type=script&lang=ts"
export * from "./ui-audio-control.vue?vue&type=script&lang=ts"
import style0 from "./ui-audio-control.vue?vue&type=style&index=0&id=4ddfc6fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddfc6fa",
  null
  
)

export default component.exports